import { observer } from 'mobx-react';
import './ToastNotifications.scss';
import { toastNotificationStore, useTranslation } from '../../platform/stores';

export const ToastNotifications = observer(() => {
  const t = useTranslation();
  const { notifications } = toastNotificationStore;

  return (
    <div className="toast-notifications-component">
      <div className="toast-notifications-container">
        {
          notifications.map((item) =>
            <div className={`toast-notification-item ${item.type} ${!item.hidden ? 'visible' : ''}`} key={item.id}>
              {t(item.text)}
            </div>
          )
        }
      </div>
    </div>
  );
});
